import { Box, CircularProgress, Typography } from '@mui/material'
import axios from 'api/axios'
import CustomTable from 'common/components/CustomTable'
import { useEffect, useState } from 'react'

export default function DatosPlanificacion({ idPlanificacion }) {
  const [loading, setLoading] = useState(true)
  const [resultados, setResultados] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)

        // Fetch datos en crudo del Gantt
        const response = await axios.get(`/planificaciones/${idPlanificacion}/gantt/`)
        setResultados(response.data.data || [])
      } catch (_error) {
        // manejar error
      } finally {
        setLoading(false)
      }
    }

    if (idPlanificacion) fetchData()
  }, [idPlanificacion])

  if (loading)
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    )

  return (
    <Box>
      {/* Tabla de datos en crudo */}
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold' }}>
          Datos en Crudo del Optimizador
        </Typography>

        <CustomTable
          dataSource={resultados}
          fields={[
            { key: 'ID', value: 'id', width: 70 },
            {
              key: 'Tipo',
              value: 'tipo',
              width: 100,
              filterable: true,
              type: 'singleSelect',
              valueOptions: ['Actividad', 'Transición', 'Arranque', 'Ocupada'],
            },
            { key: 'Máquina', value: 'maquina', width: 100 },
            { key: 'Artículo', value: 'articulo', width: 150 },
            { key: 'Cliente', value: 'cliente', width: 150 },
            { key: 'Pedido', value: 'orden_fabricacion', width: 120 },
            { key: 'Inicio', value: 'start_date', width: 160 },
            { key: 'Fin', value: 'end_date', width: 160 },
            { key: 'Familia', value: 'familia', width: 120 },
            { key: 'Esmalte', value: 'esmalte', width: 120 },
            { key: 'Cantidad', value: 'cantidad', width: 100 },
            { key: 'Retraso', value: 'retraso', width: 80 },
          ]}
          rowid="id"
          showToolbar
          density="compact"
          initialPageSize={25}
        />
      </Box>
    </Box>
  )
}
